"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _interfaces = require("@fhx/interfaces");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _CommonContentStyleModule = _interopRequireDefault(require("../CommonContentStyle.module.scss"));

var _ItemTooltipContentModule = _interopRequireDefault(require("./ItemTooltipContent.module.scss"));

var _ItemTooltipContent = _interopRequireDefault(require("./ItemTooltipContent.i18n"));

var _AttributeTable = _interopRequireDefault(require("./components/AttributeTable/AttributeTable"));

var _moneyToMoneyDivided = _interopRequireDefault(require("../../../../../helpers/money/moneyToMoneyDivided"));

var _ItemBonus = _interopRequireDefault(require("./components/ItemBonus/ItemBonus"));

var _Money = _interopRequireDefault(require("../../../../common/Money/Money"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemTooltipContent = function ItemTooltipContent(_ref) {
  var item = _ref.item,
      viewingCharacter = _ref.viewingCharacter,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var id = item.id,
      model = item.model,
      namePrefix = item.namePrefix,
      nameSuffix = item.nameSuffix,
      rarity = item.rarity,
      refinementLevel = item.refinementLevel,
      description = item.description,
      isIdentified = item.isIdentified,
      price = item.price,
      magicOpts = item.magicOpts;
  var modelId = model.id,
      name = model.name,
      particularity = model.particularity,
      isTradeable = model.isTradeable;

  function renderName() {
    var fullName = name;
    if (namePrefix) fullName = namePrefix.concat(" ".concat(fullName));
    if (nameSuffix) fullName = fullName.concat(" ".concat(nameSuffix));
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _ItemTooltipContentModule.default.name + (rarity ? " ".concat(_ItemTooltipContentModule.default[rarity.toLowerCase()]) : "")
    }, fullName, " ", refinementLevel > 0 && " +".concat(refinementLevel));
  }

  function renderBonusesNodes() {
    var nodes = [];
    magicOpts.forEach(function (entry) {
      var index = entry.index;
      nodes.push( /*#__PURE__*/_react.default.createElement(_ItemBonus.default, {
        key: index,
        magicOpt: entry
      }));
    });
    return nodes;
  }

  function renderPrice() {
    if (price < 1) return null;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _ItemTooltipContentModule.default.price
    }, formatMessage(_ItemTooltipContent.default["price-prefix"]), " \xA0\xA0", /*#__PURE__*/_react.default.createElement(_Money.default, {
      moneyDivide: (0, _moneyToMoneyDivided.default)(price),
      showNullValues: true,
      showSum: true
    }));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CommonContentStyleModule.default.content, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _CommonContentStyleModule.default.identifiers
  }, "".concat(id || "").concat(modelId && " (".concat(modelId, ")"))), renderName(), description && /*#__PURE__*/_react.default.createElement("div", {
    className: _ItemTooltipContentModule.default.description
  }, description), /*#__PURE__*/_react.default.createElement(_AttributeTable.default, {
    className: _ItemTooltipContentModule.default.attributeTable,
    item: item,
    viewingCharacter: viewingCharacter
  }), !isTradeable && /*#__PURE__*/_react.default.createElement("div", {
    className: _ItemTooltipContentModule.default.untradeable
  }, formatMessage(_ItemTooltipContent.default.untradeable), particularity === _interfaces.EItemParticularity.QUEST_REWARD && " (".concat(formatMessage(_ItemTooltipContent.default.questReward), ")")), !isIdentified && /*#__PURE__*/_react.default.createElement("div", {
    className: _ItemTooltipContentModule.default.unidentified
  }, formatMessage(_ItemTooltipContent.default.unidentified)), isIdentified && renderBonusesNodes(), renderPrice());
};

var _default = ItemTooltipContent;
exports.default = _default;